const divFormTitle = {
  typographyTrue: 'Cadastro de Novo Equipamento',
  typographyFalse: 'Editar Infos do Equipamento',
  typographyFinancialInfo: 'Editar Infos Financeiras do Equipamento',
};

export default divFormTitle;
